import React from "react";
import FormInput from "../form/FormInput";
import "./table.scss";
import GoSearch from "../../assets/GoSearch";
import Close from "../../assets/Close";

function Search(props) {
  const { search, setSearch, onChange } = props;

  return (
    <FormInput
      dom={{
        type: "text",
        name: "search",
        onChange: (e) => {
          setSearch(e.target.value);
          onChange(e.target.value);
        },
        value: search,
        placeholder: "Search",
        className:
          "px-10  leading-5 placeholder:text-grey-2200 placeholder:capitalize",
      }}
      preFix={() => <GoSearch className="absolute left-3" />}
      postFix={() =>
        search.length > 0 ? (
          <Close
            className="absolute right-4"
            onClick={() => {
              setSearch("");
              onChange("");
            }}
          />
        ) : (
          ""
        )
      }
      fullwidth={true}
    />
  );
}

export default Search;
